import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { ButtonWrapper, ModalBody } from "./Style";
import "../contact/ContactHome.css";
import Modal from "react-bootstrap/Modal";

//otp Box Design
export function OtpBox({show,onHide, otp, setOtp, handleClick, onSignUp, phone, isLoading, attempts=2}) {
  const [timer, setTimer] = useState(30);
  const [counter, setCounter] = useState(attempts);

  useEffect(() => {
    let intervalId;

    if (timer > 0) {
      intervalId = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [timer]);

  const handleChange = (otp) => setOtp(otp);

  const handleResendOtp = (e) => {
    setTimer(30); 
    setCounter(prevCounter => prevCounter - 1);
    handleClick(e); 
    setOtp("");
  }

    return (
      <>
        <Modal
          size="lg"
          id="otp-box"
          onHide={onHide}
          show={show}
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          contentClassName="otp_card"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-center"></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ModalBody>
              <h2>OTP verification</h2>
              <p>
                Please enter the One-Time Code to verify your account.
                <br />A one time code has been sent to {phone}
              </p>
              <h2>
                <OtpInput
                  inputStyle={{
                    border: "none",
                    borderBottom: "2px solid grey",
                    outline: "none",
                  }}
                  className="otp_input"
                  inputType="tel"
                  value={otp}
                  onChange={handleChange}
                  numInputs={6}
                  separator={<span>&ensp;</span>}
                />
              </h2>
              <ButtonWrapper onClick={onSignUp} disabled={otp.length !== 6 || isLoading}>{isLoading ? 'Verifying...' : 'Verify'}</ButtonWrapper>
                <>
                  {counter > 0 && 
                  <button
                  className="btn btn-link"
                  onClick={handleResendOtp}
                  disabled={timer > 0}
                  >
                    Resend one-Time Code {" "}
                    {timer > 0 && <span>00:{timer}</span>}
                  </button>
                  }
                  {counter > 0 && <h6>({counter} Attempt left)</h6>}
                  {counter <= 0 && <h6 style={{ color: "red", marginTop: "5px" }}>No attempt left! Please try again after 10 mins.</h6>} 
                  
                </>
            </ModalBody>
          </Modal.Body>
        </Modal>
      </>
    );
  }